module.exports = __webpack_public_path__ + "static/img/case6.9f1d3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Virus/Adenovirus/case6.png
// module id = 716H
// module chunks = 16